import { createFileRoute, redirect } from "@tanstack/react-router";

import { SignupForm } from "@/components/auth/sign-up-form";
import { resolveAuthRedirectTarget } from "@/lib/auth-redirect";
import { noIndexSeo } from "@/lib/seo";

import { redirectSchema } from "./-shared/redirect-schema";

export const Route = createFileRoute("/(landing)/(auth)/sign-up")({
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "Create Account | StudyOS",
			description:
				"Create a StudyOS account to build AI-powered interactive learning sessions.",
			pathname: match.pathname,
		}),
	validateSearch: redirectSchema,
	beforeLoad: async ({ search }) => {
		const _redirectTo = search?.redirect;

		if (_redirectTo) {
			const redirectTo = resolveAuthRedirectTarget(_redirectTo);

			throw redirect({ to: redirectTo });
		}
	},
});

function RouteComponent() {
	const search = Route.useSearch();

	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				<SignupForm redirectTo={resolveAuthRedirectTarget(search?.from)} />
			</div>
		</div>
	);
}
